import { Injectable } from '@angular/core';
import {
  ContactInteractionModel,
  IContactInteractionsStateError,
  IContactInteractionsStateSuccess,
  IGenericInteractionProps,
} from '@boxx/contacts-core';
import { IStoreBase } from '@boxx/core';
import { Store } from '@ngrx/store';
import * as fromActions from './contact.actions';
import * as fromContacts from './contact.reducer';
import * as fromSelector from './contact.selectors';

@Injectable()
export class ContactInteractionsStore
  implements
    IStoreBase<
      ContactInteractionModel[],
      IContactInteractionsStateSuccess,
      IContactInteractionsStateError
    >
{
  constructor(public store: Store<fromContacts.ContactState>) {}

  get data$() {
    return this.store.select(fromSelector.getContactInteractionItems);
  }

  get error$() {
    return this.store.select(fromSelector.getContactInteractionError);
  }

  get success$() {
    return this.store.select(fromSelector.getContactInteractionSuccess);
  }

  get loading$() {
    return this.store.select(fromSelector.getIsLoadingInteractions);
  }

  get fetched$() {
    return this.store.select(fromSelector.interactionsFetched);
  }

  fetch(contactId: number) {
    this.store.dispatch(
      fromActions.fetchInteractionsBeginAction({ contactId })
    );
  }

  create(contactId: number, config: IGenericInteractionProps) {
    this.store.dispatch(
      fromActions.createInteractionBeginAction({ contactId, config })
    );
  }
}
